<body>
  <div class="app-main full-height fixed-header nav-collapsed nav-behind">
    <router-outlet></router-outlet>
  </div>
</body>
